import dashboardWizard from "app/components/dashboard/widget-wizard/reducers/dashboardWizardReducer";
import dashboardCopyToUserDialog from "app/pages/dashboard/reducers/DashboardCopyToUserDialogReducer";
import dashboardSideNav from "app/pages/dashboard/reducers/DashboardSideNavReducer";
import currentDashboard from "app/pages/dashboard/redux/reducers/CurrentDashboardReducer";
import * as Redux from "redux";
import dashboardTemplate from "../../components/dashboard/dashboard-templates/reducers/dashboardTemplateReducer";

const { combineReducers } = Redux;

export const customDashboard = combineReducers({
    dashboardWizard,
    dashboardSideNav,
    dashboardTemplate,
    dashboardCopyToUserDialog,
    currentDashboard,
});
